module.exports = __webpack_public_path__ + "media/shared/assets/fonts/InterDisplay/InterDisplay-Bold-f5ec5e21f616f430d4ba27e814d9eeb6.woff2";